// Utility function for the self-service attendance modal feature
function redirectLinkParser(rawLink) {
    if (!rawLink) {
        return "";
    }

    let parsedLink = "";

    // In case the URL ends with ".com"
    if (rawLink.includes(".com/")) {
        parsedLink = rawLink.split(".com/")[1];
    }

    // In case the URL ends with ".br"
    if (rawLink.includes(".br/")) {
        parsedLink = rawLink.split(".br/")[1];
    }

    return parsedLink;
}

export default redirectLinkParser;
